// Google Maps API configuration
export const GOOGLE_MAPS_CONFIG = {
    apiKey: 'AIzaSyA82ED-tEkH-Qgzbc-SutKQN_Seyu2l8qU', // Paste your Google Maps API key here
    libraries: ['places', 'geocode'] // Required for search and geocodin
};


// Other API keys can be added here as needed
